<template lang="pug">
#product_terms
  custom-header(
    :title="fileDownloadPage.area01_Title",
    :subTitle="fileDownloadPage.area01_SubTitle",
    :image="fileDownloadPage.area01_Image",
    :buttonName="fileDownloadPage.area01_ButtonName",
    :buttonURL="fileDownloadPage.area01_ButtonURL"
  )
  section.container.i_pb_10
    .row.i_mt_6
      .col-12.text-center.d-flex.justify-content-center
        img(src="/IMAGE/CustomerService/ProductTerms_Icon.png")
        h2.i_h2_title.i_ml_1 商品條款
    .row.i_mt_10.i_mt_sm_6
      .col-12.d-flex.flex-column.flex-md-row.justify-content-center.align-items-center
        select(name="type1", v-model="select1Type", @change="option1Change")
          option(:value="option", v-for="(option, index) in option1List") {{ option.TermsFileCategoryName }}
        select.i_ml_3.i_ml_sm_0.i_mt_sm_4(
          name="type2",
          v-model="select2Type",
          @change="option2Change"
        )
          option(:value="option", v-for="(option, index) in option2List") {{ option.TermsFileMenuName }}
        .search_btn.i_ml_3.i_ml_sm_0.i_mt_sm_8(
          @click="search",
          style="cursor: pointer"
        ) 查詢
    .row.i_mt_10.i_mt_sm_8
      .col-12
        table-item(
          v-for="(terms, index) in currentTermsFile",
          :key="index",
          :terms="terms"
        )

  dedicated-line
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import TableItem from "@/components/customer_service/TableItem";
import {
  getFileDownloadPage,
  getTermsFile,
  getTermsFileCategory,
} from "@/json/customer_service";
import DedicatedLine from "@/components/customer_service/DedicatedLine";

export default {
  name: "CustomerServiceDocumentDownloadTerms",
  components: {
    "custom-header": CustomHeader,
    "dedicated-line": DedicatedLine,
    "table-item": TableItem,
  },
  data() {
    return {
      termsFileCategory: {},
      fileDownloadPage: {},
      termsFile: {},
      currentTermsFile: [],
      select1Type: "",
      select2Type: "",
      option1List: [],
      option2List: [],
    };
  },
  created() {
    this.getFileDownloadPage();
    this.getTermsFileCategory();
  },
  methods: {
    getTermsFileCategory() {
      getTermsFileCategory().then((response) => {
        this.termsFileCategory = response.data;
        this.option1List = this.termsFileCategory.TermsFileCategoryList;
        this.getTermsFile();
      });
    },
    selectOption1(index) {
      this.select1Type = this.option1List[index];
      this.option2List = this.option1List[index].TermsFileMenuList;
      this.selectOption2(0);
    },
    selectOption2(index) {
      this.select2Type = this.option2List[index];
    },
    search() {
      this.currentTermsFile = [];
      for (let index in this.termsFile.TermsFileList) {
        let temp = this.termsFile.TermsFileList[index];
        if (temp.TermsFileMenuID == this.select2Type.TermsFileMenuID) {
          this.currentTermsFile.push(temp);
        }
      }
    },
    option1Change() {
      this.selectOption1(this.option1List.indexOf(this.select1Type));
    },
    option2Change() {
      this.selectOption2(this.option2List.indexOf(this.select2Type));
    },
    getFileDownloadPage() {
      getFileDownloadPage().then((response) => {
        this.fileDownloadPage = response.data;
      });
    },
    getTermsFile() {
      getTermsFile().then((response) => {
        this.termsFile = response.data;
        this.selectOption1(0);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/product_terms";
</style>
